import script from "./return-documents.vue?vue&type=script&lang=ts&setup=true"
export * from "./return-documents.vue?vue&type=script&lang=ts&setup=true"

import "./return-documents.vue?vue&type=style&index=0&id=5d3d3198&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d3d3198"]])

export default __exports__